module.exports = __webpack_public_path__ + "static/elementalist_icon-ab04749ac02333159cc5156aff2c0f7e.png";